export default __webpack_public_path__ + "static/media/sinosserra-branco.20d07a13.svg";